import com.soywiz.korge.input.Input
import game.CgaColor
import game.Game
import game.controller.GameController
import game.controller.PlayController
import game.entity.AnimationEntity
import view.Terminal

class LobbyTrapController : GameController() {
    var step = 0
    var coolDown = 0
    var renderPlayer = true
    override fun onTick(game: Game, input: Input) {
        game.currentRoom.tick(game)

        if (coolDown != 0) {
            coolDown--
        } else {
            when (step) {
                0 -> {
                    drawTrapSlit(game, 25, 10)
                    nextStep(game)
                }
                1 -> {
                    drawTrapSlit(game, 24, 10)
                    drawTrapSlit(game, 26, 10)
                    nextStep(game)
                }
                2 -> {
                    drawTrapSlit(game, 23, 10)
                    drawTrapSlit(game, 27, 10)
                    nextStep(game)
                }
                3 -> {
                    drawTrapSlit(game, 22, 10)
                    drawTrapSlit(game, 28, 10)
                    nextStep(game)
                }
                4 -> {
                    drawTrapSlit(game, 21, 10)
                    drawTrapSlit(game, 29, 10)
                    nextStep(game)
                }
                5 -> {
                    game.playSound("fall")

                    val playerFall = AnimationEntity()
                    playerFall.sprite = game.getSpriteById("player-fall")
                    playerFall.col = game.player.col
                    playerFall.row = game.player.row

                    game.currentRoom.addEntity(playerFall)

                    renderPlayer = false
                    step++
                    coolDown = 100
                }
                6 -> {
                    game.startTeleportTransition(
                        game.player.col,
                        game.player.row,
                        25,
                        8,
                        "L2R43",
                        false
                    )

                    step++
                }
                7 -> {
                    game.player.col = 25
                    game.player.row = 0

                    renderPlayer = true
                    coolDown = 10
                    step++
                }
                8 -> {
                    game.player.row++

                    if (game.player.row == 8) {
                        step++
                        game.playSound("damage")
                    }

                    coolDown = 2

                }
                9 -> {
                    game.showDialog("Dialog_Start")
                    step++
                }
                10 -> {
                    game.saveGame()
                    game.controller = PlayController()
                }
            }
        }
    }

    override fun onRender(game: Game, terminal: Terminal) {
        game.renderRoom(terminal)
        if (renderPlayer) {
            game.renderPlayer(terminal)
        }
    }

    private fun nextStep(game: Game) {
        game.playSound("floor-trap")
        step++
        coolDown = 25
    }

    private fun drawTrapSlit(game: Game, col: Int, row: Int) {
        with(game.currentRoom[col, row]) {
            char = 0xDB
            fgColor = CgaColor.BLACK.rgba
            bgColor = CgaColor.DARK_GRAY.rgba
        }
        with(game.currentRoom[col, row - 1]) {
            char = 0xDC
            fgColor = CgaColor.BLACK.rgba
            bgColor = CgaColor.DARK_GRAY.rgba
        }
    }
}